<template>
  <div class="contracts-list-container">
    <!-- 顶部标题栏 -->
    <div class="page-header">
      <div class="header-title">
        <div class="title-mark"></div>
        <span>合同管理</span>
      </div>
    </div>
    
    <!-- Tab和搜索区域容器 -->
    <div class="tabs-search-container">
      <!-- Tab切换 -->
      <el-tabs v-model="activeTab" @tab-click="handleTabChange" class="contract-tabs">
        <el-tab-pane label="采购合同" name="purchase"></el-tab-pane>
        <el-tab-pane label="销售合同" name="sales"></el-tab-pane>
      </el-tabs>
      
      <!-- 搜索区域 -->
      <div class="search-area">
      <el-input
        v-model="searchParams.contract_name"
        placeholder="合同名称"
        clearable
        class="search-input"
        prefix-icon="el-icon-search"
      ></el-input>
      
      <el-select
        v-model="searchParams.contract_unit"
        placeholder="合同单位"
        clearable
        class="search-input"
        filterable
      >
        <el-option
          v-for="unit in unitOptions"
          :key="unit.id"
          :label="unit.unitName || unit.unit_name"
          :value="unit.id"
        ></el-option>
      </el-select>
      
      <el-select
        v-model="searchParams.supplier_unit"
        placeholder="供方单位"
        clearable
        class="search-input"
        filterable
      >
        <el-option
          v-for="unit in supplierOptions"
          :key="unit.id"
          :label="unit.unit_name || unit.unitName"
          :value="unit.id"
        ></el-option>
      </el-select>
      
      <el-select
        v-model="searchParams.customer_unit"
        placeholder="需求方单位"
        clearable
        class="search-input"
        filterable
      >
        <el-option
          v-for="unit in customerOptions"
          :key="unit.id"
          :label="unit.unit_name || unit.unitName"
          :value="unit.id"
        ></el-option>
      </el-select>
      
      <el-select
        v-model="searchParams.status"
        placeholder="合同状态"
        clearable
        class="search-input"
      >
        <el-option
          v-for="item in statusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      
      <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
      <el-button v-permission="'contracts:contracts-list:create'" type="success" @click="createContract" icon="el-icon-plus">新增合同</el-button>
      </div>
    </div>
    
    <!-- 合同列表 -->
    <el-table
      :data="contractList"
      border
      style="width: 100%"
      v-loading="loading"
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
    >
      <el-table-column
        prop="contractName"
        label="合同名称"
        min-width="280"
        align="center"
      ></el-table-column>
      
                   <el-table-column
        prop="contractNumber"
        label="合同编号"
        min-width="200"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.contractNumber || '未生成' }}</span>
        </template>
      </el-table-column>
      
             <el-table-column
         label="供方单位"
         min-width="220"
         align="center"
       >
         <template slot-scope="scope">
           <span v-if="scope.row.supplierUnit">{{ scope.row.supplierUnit.unitName }}</span>
           <span v-else-if="scope.row.supplierUnitId">{{ getUnitName(scope.row.supplierUnitId) }}</span>
           <span v-else>{{ getSupplierFromParties(scope.row.contractParties) }}</span>
         </template>
       </el-table-column>
      
             <el-table-column
         label="需求方单位"
         min-width="200"
         align="center"
       >
         <template slot-scope="scope">
           <div v-if="scope.row.demandUnits && scope.row.demandUnits.length > 0">
             <el-tag 
               v-for="unit in scope.row.demandUnits" 
               :key="unit.id"
               size="small"
               style="margin-right: 5px; margin-bottom: 5px;"
             >
               {{ unit.unitName }}
             </el-tag>
           </div>
           <div v-else-if="scope.row.demandUnitIds && scope.row.demandUnitIds.length > 0">
             <el-tag 
               v-for="customerId in scope.row.demandUnitIds" 
               :key="customerId"
               size="small"
               style="margin-right: 5px; margin-bottom: 5px;"
             >
               {{ getUnitName(customerId) }}
             </el-tag>
           </div>
           <span v-else>
             {{ getCustomerFromParties(scope.row.contractParties) }}
             <!-- 调试信息 -->
             <el-tooltip v-if="scope.row.contractParties && scope.row.contractParties.length > 0" 
                        :content="`参与方数量: ${scope.row.contractParties.length}, 客户: ${scope.row.contractParties.filter(p => p.partyType === 'CUSTOMER').length}`" 
                        placement="top">
               <i class="el-icon-info" style="margin-left: 5px; color: #909399;"></i>
             </el-tooltip>
           </span>
         </template>
       </el-table-column>
      
             
      
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          {{ formatDate(scope.row.createTime) }}
        </template>
      </el-table-column>
      
      <el-table-column
        prop="status"
        label="状态"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag :type="getStatusTagType(scope.row.status)">
            {{ getStatusText(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      
      <el-table-column
        label="操作"
        width="360"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <el-button
              type="primary"
              size="mini"
              @click="viewContract(scope.row.id)"
            >查看</el-button>
            
            <el-button
              v-if="canEditContract(scope.row)"
              v-permission="'contracts:contracts-list:edit'"
              type="warning"
              size="mini"
              @click="editContract(scope.row.id)"
            >编辑</el-button>
            
            <el-button
              v-permission="'contracts:contracts-list:create'"
              type="success"
              size="mini"
              @click="manageProjects(scope.row)"
            >关联项目</el-button>
            
            <el-button
              v-if="canRollbackContract(scope.row)"
              type="info"
              size="mini"
              @click="rollbackContract(scope.row.id)"
            >退回</el-button>
            
            <el-button
              v-if="canDeleteContract(scope.row)"
              v-permission="'contracts:contracts-list:delete'"
              type="danger"
              size="mini"
              @click="deleteContract(scope.row.id)"
            >删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
    
    <!-- 关联项目管理对话框 -->
    <el-dialog
      v-dialog-drag
      title="关联项目管理"
      :visible.sync="projectDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      :show-close="true"
      center
    >
      <div class="project-dialog-content">
        <!-- 合同信息 -->
        <div class="contract-info">
          <h4>合同信息</h4>
          <p><strong>合同名称：</strong>{{ currentContract.contractName }}</p>
          <p><strong>合同编号：</strong>{{ currentContract.contractNumber || '未生成' }}</p>
        </div>
        
        <!-- 已关联项目 -->
        <div class="linked-projects">
          <h4>已关联项目</h4>
          <div v-if="linkedProjects.length > 0" class="project-list">
            <el-tag
              v-for="project in linkedProjects"
              :key="project.id"
              size="medium"
              closable
              @close="removeProject(project.id)"
              style="margin-right: 10px; margin-bottom: 10px;"
            >
              {{ project.projectName }}
            </el-tag>
          </div>
          <div v-else class="no-projects">
            <el-empty description="暂无关联项目" :image-size="80"></el-empty>
          </div>
        </div>
        
        <!-- 添加项目 -->
        <div class="add-projects">
          <h4>添加项目</h4>
          <div class="add-project-form">
            <el-select
              v-model="selectedProjectIds"
              placeholder="请选择要关联的项目"
              multiple
              filterable
              style="width: 400px; margin-right: 10px;"
            >
              <el-option
                v-for="project in availableProjects"
                :key="project.id"
                :label="project.projectName"
                :value="project.id"
              ></el-option>
            </el-select>
            <el-button 
              type="primary" 
              @click="addProjects"
              :disabled="selectedProjectIds.length === 0"
            >添加选中项目</el-button>
          </div>
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="projectDialogVisible = false">关闭</el-button>
        <el-button v-permission="'contracts:contracts-list:create'" type="primary" @click="saveProjectChanges" :loading="savingProjects">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { getUserInfo } from '@/utils/auth.js';
import { 
  del_contract_by_id, 
  updateContractStatus,
  query_purchase_contracts_pagination,
  query_sales_contracts_pagination
} from '@/api/modules/contracts.js';
import { getAllUnits, getAllSuppliersByUnitId, getAllCustomersByUnitId } from '@/api/modules/unit.js';
import { getProjectsByUnit } from '@/api/modules/projects.js';
import moment from 'moment';

export default {
  name: 'ContractsList',
  data() {
    return {
      activeTab: 'purchase', // 默认显示采购合同
      searchParams: {
        contract_name: '',
        contract_unit: '',
        supplier_unit: '',
        customer_unit: '',
        status: '',
        create_id: '' // 当前用户单位ID
      },
      statusOptions: [
        { value: 'DRAFT', label: '草稿' },
        { value: 'PENDING_REVIEW', label: '待复核' },
        { value: 'ACTIVE', label: '签订' },
        { value: 'EXECUTING', label: '执行中' },
        { value: 'SETTLED', label: '决算' },
        { value: 'FINISHED', label: '收尾' },
        { value: 'TERMINATED', label: '终止' }
      ],
      contractList: [],
      unitOptions: [], // 所有单位选项
      supplierOptions: [], // 供应商选项
      customerOptions: [], // 客户选项
      projectOptions: [], // 项目选项
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 关联项目管理相关
      projectDialogVisible: false,
      currentContract: {},
      linkedProjects: [],
      selectedProjectIds: [],
      savingProjects: false
    }
  },
  computed: {
    // 可用项目列表（排除已关联的项目）
    availableProjects() {
      const linkedProjectIds = this.linkedProjects.map(p => p.id);
      return this.projectOptions.filter(project => !linkedProjectIds.includes(project.id));
    }
  },
  created() {
    // 恢复上次保存的tab状态
    const savedTab = sessionStorage.getItem('contracts_active_tab');
    if (savedTab) {
      this.activeTab = savedTab;
    }
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      await this.fetchUnits();
      await this.fetchProjects();
      await this.fetchContracts();
    },
    
    // 获取单位列表
    async fetchUnits() {
      try {
        const currentUser = getUserInfo();
        const currentUnitId = currentUser?.unit_id || currentUser?.unitId || 1;
        
        // 获取所有单位
        const unitsResponse = await getAllUnits();
        if (unitsResponse.data && unitsResponse.data.success) {
          this.unitOptions = unitsResponse.data.data || [];
        }
        
        // 获取供应商
        const suppliersResponse = await getAllSuppliersByUnitId(currentUnitId);
        if (suppliersResponse.data && suppliersResponse.data.success) {
          this.supplierOptions = suppliersResponse.data.data || [];
        }
        
        // 获取客户
        const customersResponse = await getAllCustomersByUnitId(currentUnitId);
        if (customersResponse.data && customersResponse.data.success) {
          this.customerOptions = customersResponse.data.data || [];
        }
      } catch (error) {
        console.error('获取单位数据失败:', error);
        this.$message.error('获取单位数据失败');
      }
    },
    
    // 获取项目列表
    async fetchProjects() {
      try {
        const currentUser = getUserInfo();
        const currentUnitId = currentUser?.unit_id || currentUser?.unitId;
        
        if (!currentUnitId) {
          console.warn('未能获取当前用户单位ID');
          return;
        }
        
        const response = await getProjectsByUnit(currentUnitId);
        if (response.data && response.data.success) {
          this.projectOptions = response.data.data || [];
} else {
          console.warn('获取项目列表失败:', response);
          this.projectOptions = [];
        }
      } catch (error) {
        console.error('获取项目数据失败:', error);
        this.projectOptions = [];
      }
    },
    
    // 获取合同列表
    async fetchContracts() {
      this.loading = true;
      try {
        const currentPage = this.pagination.currentPage;

        // 构建查询参数
        const params = {
          page: currentPage,
          size: this.pagination.pageSize
        };
        
        // 添加合同名称搜索（如果提供）
        if (this.searchParams.contract_name) {
          params.contractName = this.searchParams.contract_name;
        }
        
        // 添加状态筛选（如果提供）
        if (this.searchParams.status) {
          params.status = this.searchParams.status;
        }
        
        // 根据当前tab选择不同的API
        let response;
        if (this.activeTab === 'purchase') {
          // 查询采购合同，系统会自动根据当前登录用户过滤
          response = await query_purchase_contracts_pagination(params);
        } else {
          // 查询销售合同，系统会自动根据当前登录用户过滤
          response = await query_sales_contracts_pagination(params);
        }

        if (response.data && response.data.success) {
          const responseData = response.data.data;

          let list = [];
          let total = 0;

          if (Array.isArray(responseData)) {
            list = responseData;
            total = response.data.total || responseData.length || 0;
          } else if (responseData?.records && Array.isArray(responseData.records)) {
            list = responseData.records;
            total = responseData.total || 0;
          } else if (responseData?.content && Array.isArray(responseData.content)) {
            list = responseData.content;
            total = responseData.totalElements || responseData.total || 0;
          } else if (responseData?.list && Array.isArray(responseData.list)) {
            list = responseData.list;
            total = responseData.total || responseData.totalCount || 0;
          } else if (Array.isArray(response.data.items)) {
            list = response.data.items;
            total = response.data.total || response.data.itemsTotal || 0;
          }

          this.contractList = list;
          this.pagination.total = total;

          // 调试信息：打印第一个合同的数据结构
          
        } else {
          this.$message.error(response.data?.message || '获取合同列表失败');
        }
      } catch (error) {
        console.error('获取合同列表失败:', error);
        this.$message.error('获取合同列表失败');
      } finally {
        this.loading = false;
      }
    },
    
    // Tab切换处理
    handleTabChange() {
      this.pagination.currentPage = 1;
      // 保存当前tab状态
      sessionStorage.setItem('contracts_active_tab', this.activeTab);
      this.fetchContracts();
    },
    
    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchContracts();
    },
    
    // 新增合同
    createContract() {
      this.$router.push('/contracts/create');
    },
    
    // 查看合同
    viewContract(id) {
      this.$router.push(`/contracts/view/${id}`);
    },

    // 编辑合同
    editContract(id) {
      this.$router.push(`/contracts/edit/${id}`);
    },
    
    // 删除合同
    deleteContract(id) {
      this.$confirm('确定要删除该合同吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await del_contract_by_id(id);
          if (response.data && response.data.success) {
            this.$message.success('删除成功');
            this.fetchContracts();
          } else {
            this.$message.error(response.data?.message || '删除失败');
          }
        } catch (error) {
          console.error('删除合同失败:', error);
          this.$message.error('删除合同失败');
        }
      }).catch(() => {
        // 用户取消删除
      });
    },
    
    // 退回合同
    rollbackContract(id) {
      this.$confirm('确定要将合同退回到签订状态吗？', '退回确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await updateContractStatus(id, 'ACTIVE');
          if (response.data && response.data.success) {
            this.$message.success('合同已退回到签订状态');
            this.fetchContracts();
          } else {
            this.$message.error(response.data?.message || '退回失败');
          }
        } catch (error) {
          console.error('退回合同失败:', error);
          this.$message.error('退回合同失败: ' + (error.response?.data?.message || error.message || '未知错误'));
        }
      }).catch(() => {
        // 用户取消退回
      });
    },
    
    // 分页大小变化
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.fetchContracts();
    },
    
    // 页码变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetchContracts();
    },
    
    // 获取单位名称
    getUnitName(unitId) {
      if (!unitId) return '未知单位';
      const unit = this.unitOptions.find(u => u.id === unitId);
      return unit ? (unit.unitName || unit.unit_name) : '未知单位';
    },
    
    // 获取项目名称
    getProjectName(projectId) {
      if (!projectId) return '未知项目';
      const project = this.projectOptions.find(p => p.id === projectId);
      return project ? project.projectName : '未知项目';
    },
    

    
    // 从合同参与方中获取供方单位名称
    getSupplierFromParties(contractParties) {
      if (!contractParties || !Array.isArray(contractParties)) return '未设置';
      const supplier = contractParties.find(party => party.partyType === 'SUPPLIER');
      return supplier && supplier.unitInfo ? supplier.unitInfo.unitName : '未设置';
    },
    
          // 从合同参与方中获取需求方单位名称
      getCustomerFromParties(contractParties) {
        if (!contractParties || !Array.isArray(contractParties)) return '未设置';
        const customers = contractParties.filter(party => party.partyType === 'CUSTOMER');
        if (customers.length === 0) return '未设置';
        
        // 如果有多个客户，显示第一个客户名称 + 等X家
        if (customers.length > 1) {
          const firstCustomer = customers.find(c => c.unitInfo && c.unitInfo.unitName);
          if (firstCustomer) {
            return `${firstCustomer.unitInfo.unitName} 等${customers.length}家`;
          }
        }
        
        // 如果只有一个客户或者第一个客户没有名称，返回第一个有效的客户名称
        const validCustomer = customers.find(c => c.unitInfo && c.unitInfo.unitName);
        return validCustomer ? validCustomer.unitInfo.unitName : '未设置';
      },
    
    // 获取状态标签类型
    getStatusTagType(status) {
      const statusMap = {
        'DRAFT': 'info',
        'PENDING_REVIEW': 'warning',
        'ACTIVE': 'success',
        'EXECUTING': 'warning',
        'SETTLED': 'success',
        'FINISHED': 'success',
        'TERMINATED': 'danger'
      };
      return statusMap[status] || 'info';
    },
    
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        'DRAFT': '草稿',
        'PENDING_REVIEW': '待复核',
        'ACTIVE': '签订',
        'EXECUTING': '执行中',
        'SETTLED': '决算',
        'FINISHED': '收尾',
        'TERMINATED': '终止'
      };
      return statusMap[status] || status;
    },
    
    // 判断状态是否可编辑
    isEditableStatus(status) {
      return ['DRAFT', 'ACTIVE'].includes(status);
    },

    // 判断合同是否可编辑或删除
    canEditContract(contract) {
      const currentUser = getUserInfo();
      const currentUnitId = currentUser?.unit_id || currentUser?.unitId;
      const currentUserId = currentUser?.id || currentUser?.userId || currentUser?.user_id;

      // 复核退回的草稿只能由合同原创建人重新编辑提交
      if (contract.status === 'DRAFT') {
        return Number(contract.creatorId) === Number(currentUserId);
      }

      if (contract.status !== 'ACTIVE') return false;

      // 检查是否为合同创建者 - 多种方式判断
      // 1. 通过create_id字段（单位ID）
      if (contract.create_id === currentUnitId) {
return true;
      }
      
      // 2. 通过creatorId字段（用户ID）
      if (contract.creatorId === currentUserId) {
return true;
      }
      
      // 3. 通过contractParties中的创建者信息
      if (contract.contractParties && contract.contractParties.length > 0) {
        const creatorParty = contract.contractParties.find(party => 
          party.isPrimary === true || party.partyType === 'CONTRACT_UNIT'
        );
        if (creatorParty && creatorParty.unitInfoId === currentUnitId) {
return true;
        }
      }
      
      // 4. 通过contractUnitId字段
      if (contract.contractUnitId === currentUnitId) {
return true;
      }

return false;
    },

    // 删除保持原有规则，不随草稿编辑权限一起放开
    canDeleteContract(contract) {
      return contract.status === 'ACTIVE' && this.canEditContract(contract);
    },
    
    // 判断合同是否可以退回
    canRollbackContract(contract) {
      const currentUser = getUserInfo();
      const currentUnitId = currentUser?.unit_id || currentUser?.unitId;
      const currentUserId = currentUser?.id || currentUser?.userId;

      // 调试信息
// 检查合同状态是否为EXECUTING（执行中）
      if (contract.status !== 'EXECUTING') {
return false;
      }

      // 检查是否为合同创建者 - 多种方式判断
      // 1. 通过create_id字段（单位ID）
      if (contract.create_id === currentUnitId) {
return true;
      }
      
      // 2. 通过creatorId字段（用户ID）
      if (contract.creatorId === currentUserId) {
return true;
      }
      
      // 3. 通过contractParties中的创建者信息
      if (contract.contractParties && contract.contractParties.length > 0) {
        const creatorParty = contract.contractParties.find(party => 
          party.isPrimary === true || party.partyType === 'CONTRACT_UNIT'
        );
        if (creatorParty && creatorParty.unitInfoId === currentUnitId) {
return true;
        }
      }
      
      // 4. 通过contractUnitId字段
      if (contract.contractUnitId === currentUnitId) {
return true;
      }

return false;
    },
    
    // 格式化日期
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    
    // 管理关联项目
    async manageProjects(contract) {
      this.currentContract = contract;
      this.projectDialogVisible = true;
      
      // 获取合同的关联项目
      await this.loadContractProjects(contract.id);
    },
    
    // 加载合同的关联项目
    async loadContractProjects(contractId) {
      try {
        // 获取合同详情来获取关联项目
        const { getContractById } = await import('@/api/modules/contracts.js');
        const response = await getContractById(contractId);
        
        if (response.data && response.data.success) {
          const contractDetail = response.data.data;
          
          // 从合同详情中提取关联项目
          this.linkedProjects = [];
          
          if (contractDetail.projects && contractDetail.projects.length > 0) {
            this.linkedProjects = contractDetail.projects;
          } else if (contractDetail.projectIds && contractDetail.projectIds.length > 0) {
            // 根据项目ID数组获取项目详情
            this.linkedProjects = contractDetail.projectIds.map(projectId => {
              const project = this.projectOptions.find(p => p.id === projectId);
              return project || { id: projectId, projectName: '未知项目' };
            });
          }
          
} else {
          this.$message.error('获取合同项目信息失败');
        }
      } catch (error) {
        console.error('加载合同项目失败:', error);
        this.$message.error('加载合同项目失败');
      }
    },
    
    // 移除项目关联
    removeProject(projectId) {
      this.linkedProjects = this.linkedProjects.filter(project => project.id !== projectId);
    },
    
    // 添加选中的项目
    addProjects() {
      if (this.selectedProjectIds.length === 0) {
        this.$message.warning('请选择要添加的项目');
        return;
      }
      
      // 根据选中的项目ID获取项目详情并添加到关联列表
      this.selectedProjectIds.forEach(projectId => {
        const project = this.projectOptions.find(p => p.id === projectId);
        if (project && !this.linkedProjects.find(lp => lp.id === projectId)) {
          this.linkedProjects.push(project);
        }
      });
      
      // 清空选择
      this.selectedProjectIds = [];
      
      this.$message.success('项目添加成功');
    },
    
    // 保存项目关联变更
    async saveProjectChanges() {
      try {
        this.savingProjects = true;
        
        const { updateContractProjects } = await import('@/api/modules/contracts.js');
        
        // 提取项目ID数组
        const projectIds = this.linkedProjects.map(project => project.id);
        
const response = await updateContractProjects(this.currentContract.id, projectIds);
        
        if (response.data && response.data.success) {
          this.$message.success('项目关联更新成功');
          this.projectDialogVisible = false;
          
          // 刷新合同列表
          this.fetchContracts();
        } else {
          this.$message.error(response.data?.message || '项目关联更新失败');
        }
      } catch (error) {
        console.error('保存项目关联失败:', error);
        this.$message.error('保存项目关联失败: ' + (error.response?.data?.message || error.message || '未知错误'));
      } finally {
        this.savingProjects = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.contracts-list-container {
  padding: 20px;
  background-color: #f0f2f5;
}

.page-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.header-title {
  display: flex;
  align-items: center;
}

.title-mark {
  width: 4px;
  height: 20px;
  background-color: #409EFF;
  margin-right: 8px;
}

.header-title span {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.tabs-search-container {
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 20px;
  overflow: hidden;
}

.contract-tabs {
  padding: 0 20px;
  margin-bottom: 0;
}

.search-area {
  padding: 20px;
  padding-top: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
}

.search-input {
  width: 200px;
}

.pagination-container {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  text-align: right;
}

::v-deep .el-table th {
  background-color: #f5f7fa;
}

::v-deep .el-table--border {
  border-radius: 4px;
  overflow: hidden;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #409EFF;
}

// 关联项目对话框样式
.project-dialog-content {
  .contract-info {
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
    
    h4 {
      margin: 0 0 10px 0;
      color: #333;
      font-size: 16px;
      font-weight: 500;
    }
    
    p {
      margin: 5px 0;
      color: #666;
      
      strong {
        color: #333;
        margin-right: 10px;
      }
    }
  }
  
  .linked-projects, .add-projects {
    margin-bottom: 20px;
    
    h4 {
      margin: 0 0 15px 0;
      color: #333;
      font-size: 16px;
      font-weight: 500;
      padding-bottom: 10px;
      border-bottom: 1px solid #ebeef5;
    }
  }
  
  .project-list {
    min-height: 80px;
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
    padding: 15px;
    background-color: #fafafa;
  }
  
  .no-projects {
    text-align: center;
    padding: 20px;
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
    background-color: #fafafa;
  }
  
  .add-project-form {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }
}
</style>

